import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardCard from "../Components/DashboardCard";
import CategoryCard from "../Components/CategoryCard";
import PriceCategoryCard from "../Components/PriceCategoryCard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HiMiniDocumentChartBar, HiMiniDocumentCheck, HiMiniDocumentMagnifyingGlass } from "react-icons/hi2";
import { RiDiscountPercentFill } from "react-icons/ri";
import { AiFillEuroCircle } from "react-icons/ai";
import { MdAccountBalanceWallet } from "react-icons/md";
import { PiHashStraightFill } from "react-icons/pi";
import { FaBalanceScale } from "react-icons/fa";
import LoadingIndicator from "../utils/loading/LoadingIndicator";
import { useLoading } from "../utils/loading/LoadingContext";
import "./styles/dashboard.css";
import { AiFillAmazonCircle } from "react-icons/ai";
import { PiPackageFill } from "react-icons/pi";
import { HiReceiptTax } from "react-icons/hi";
import "./styles/dashboard.css";
import { FaCircle } from "react-icons/fa";
export default function ManagerDashboard() {
  const [counts, setCounts] = useState({
    received_count: 0,
    missing_count: 0,
    manifest_count: 0,
    average_recovery_rate: 0,
    average_unit_recovery: 0,
    total_recovery_sum: 0,
    total_units_sum: 0,
    total_weight_sum: 0,
    total_unitCost_sum:0,
  });
  const [selectedTable, setSelectedTable] = useState(localStorage.getItem("selectedTable") || "Manifest");
  const [startDate, setStartDate] = useState(localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : null);
  const [endDate, setEndDate] = useState(localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : null);
  const { isLoading, setLoading } = useLoading();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSimpleUser, setIsSimpleUser] = useState(false);
  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
  const formatApiDate = (date) => {
    // Adjust for timezone offset to ensure the correct date is sent
    const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return adjustedDate.toISOString().split('T')[0];
};

  useEffect(() => {
    setLoading(true);
    const params = {
      table: selectedTable,
      start_date: startDate ? formatApiDate(startDate) : null,
      end_date: endDate ? formatApiDate(endDate) : null,
    };

    axios
      .get(`${baseUrl}/api/dashboard_item_counts/`, { params })
      .then((response) => {
        setCounts(response.data);
        console.log(baseUrl);
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching the dashboard counts!", error);
        setLoading(false);
      });

    const admin = localStorage.getItem("admin") === "true";
    const simpleUser = localStorage.getItem("simple_user") === "true";
    setIsAdmin(admin);
    setIsSimpleUser(simpleUser);
  }, [baseUrl, selectedTable, startDate, endDate, setLoading]);


  useEffect(() => {
    localStorage.setItem("selectedTable", selectedTable);
  }, [selectedTable]);

  useEffect(() => {
    if (startDate) {
      localStorage.setItem("startDate", startDate.toISOString());
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
      localStorage.setItem("endDate", endDate.toISOString());
    }
  }, [endDate]);
  const getTableLabel = (baseLabel) => {
    switch (selectedTable) {
      case "ReceivedItems":
        return `Received`;
      case "MissingItems":
        return `Missing`;
      default:
        return `Manifest`;
    }
  };
  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    localStorage.removeItem('startDate');
    localStorage.removeItem('endDate');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return formattedDate;
  };



  return (
    <div className="master-body">
      <div className="dashboard-top-section">
        <div className="table-selection">
          <h3 className="select-table-drop">Select Table: </h3>
          <select
            id="table-select"
            value={selectedTable}
            onChange={(e) => setSelectedTable(e.target.value)}
            className="source-dropdown"
          >
            <option value="Manifest">Manifest Items</option>
            <option value="ReceivedItems">Received Items</option>
            <option value="MissingItems">Missing Items</option>
          </select>
        </div>

        <div className="date-selection">
         
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText="Start Date"
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText="End Date"
          />
          <button className="clear-button" onClick={handleClearDates}>
        Clear Dates
      </button>
        </div>
      <div className="latest-manifest-date">
        <span className="manifest-date-heading">Database Updated Till:</span>
        <p><span></span>{counts.latest_manifest_publish_date ? formatDate(counts.latest_manifest_publish_date) : 'Fetching...' }</p>
      </div>

      </div>
    <div className="dashboard-body">
      
     
      <div className="item-count-container">
      
        <DashboardCard
          count={counts.manifest_count}
          label="Manifest Items"
          name="manifest-item-count"
          icon={HiMiniDocumentChartBar}
          iconColor="#A73FEB"
          headingColor= "#fff"
          labelColor="#fff"
          changeColor="#fff"
          table={"All Time"}
        />
     
     <DashboardCard
          count={counts.received_count}
          label="Received Items"
          name="received-item-count"
          icon={HiMiniDocumentCheck}
          iconColor="#2DAE31" 
          headingColor= "#fff"
          labelColor="#fff"
          changeColor="#fff"
          table={"All Time"}
        />
     
     <DashboardCard
          count={counts.missing_count}
          label="Missing Items"
          name="missing-item-count"
          icon={HiMiniDocumentMagnifyingGlass}
          iconColor="#DF6C2A" 
          headingColor= "#fff"
          labelColor="#fff"
          changeColor="#fff"
          table={"All Time"}
        />
      
          <DashboardCard
          count={`${counts.total_units_sum ?? "0"}`}
          label={`Total Units`}
          name="total-units-sum"
          icon={PiHashStraightFill}
          iconColor="#264FE6" 
          table={getTableLabel("Units")}
        />

        
        
      
      
      
       
         <DashboardCard
          count={`${counts.total_weight_sum?.toFixed(2) ?? "0"}`}
          label={`Total Weight (KG)`}
          name="total-weight-sum"
          icon={FaBalanceScale}
          iconColor="#264FE6" 
          table={getTableLabel("Weight")}
        />
       

       
      
      
        <DashboardCard
          count={`${counts.unique_bol_count ?? "0"}`}
          label={`Packets`}
          name="total-packets"
          icon={PiPackageFill}
          iconColor="#264FE6" 
          table={getTableLabel("uniTCost")}
        />
     
        
      </div>
      <div className="category-container">
      <CategoryCard
        selectedTable={selectedTable}
        startDate={startDate}
        endDate={endDate}
      />
      
      </div>
     
       
    
    </div>
   
    </div>
  );
}
